export const getPriorityColor = (priority: string): string => {
  switch (priority) {
    case 'urgent': return 'bg-red-100 text-red-700 border-red-200';
    case 'high': return 'bg-orange-100 text-orange-700 border-orange-200';
    case 'medium': return 'bg-yellow-100 text-yellow-700 border-yellow-200';
    case 'low': return 'bg-green-100 text-green-700 border-green-200';
    default: return 'bg-gray-100 text-gray-700 border-gray-200';
  }
};

export const getStatusColor = (status: string): string => {
  switch (status) {
    case 'completed': return 'bg-green-100 text-green-700 border-green-200';
    case 'in_progress': return 'bg-blue-100 text-blue-700 border-blue-200';
    case 'pending': return 'bg-yellow-100 text-yellow-700 border-yellow-200';
    case 'cancelled': return 'bg-gray-100 text-gray-700 border-gray-200';
    default: return 'bg-gray-100 text-gray-700 border-gray-200';
  }
};

export const getStatusIcon = (status: string): string => {
  switch (status) {
    case 'completed': return '✅';
    case 'in_progress': return '🔄';
    case 'pending': return '⏳';
    case 'cancelled': return '❌';
    default: return '⏳';
  }
};

export const getPriorityIcon = (priority: string): string => {
  switch (priority) {
    case 'urgent': return '🔴';
    case 'high': return '🟠';
    case 'medium': return '🟡';
    case 'low': return '🟢';
    default: return '🟡';
  }
};

export const formatTaskStatus = (status: string): string => {
  return status.replace('_', ' ').charAt(0).toUpperCase() + status.replace('_', ' ').slice(1);
};

export const formatTaskPriority = (priority: string): string => {
  return priority.charAt(0).toUpperCase() + priority.slice(1);
}; 